// extracted by mini-css-extract-plugin
export default {"video-link":"t_b5 d-flex align-items-center my-2","video-link__link":"t_b6 ml-2"};